export default "__VITE_ASSET__BOmkFE7I__"